export default {
  name: 'greatboss',
  env: 'preGreatboss',
  baseURL: `https://pre.greatboss.com`,
  wxMpRegisterUrlBase: `https://m.greatboss.com`,
}
